import { render, staticRenderFns } from "./message-input-editor.vue?vue&type=template&id=386f9402&scoped=true"
import script from "./message-input-editor.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-input-editor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./message-input-editor.vue?vue&type=style&index=0&id=386f9402&prod&scoped=true&lang=scss"
import style1 from "./message-input-editor.vue?vue&type=style&index=1&id=386f9402&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386f9402",
  null
  
)

export default component.exports